import { render, staticRenderFns } from "./AppCarouselPostNotificationItem.vue?vue&type=template&id=252b48de"
import script from "./AppCarouselPostNotificationItem.vue?vue&type=script&lang=js"
export * from "./AppCarouselPostNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./AppCarouselPostNotificationItem.vue?vue&type=style&index=0&id=252b48de&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports